module.exports = __webpack_public_path__ + "static/media/back forma@2x.d054b089.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/back forma@2x.png
// module id = 80
// module chunks = 0